export const defaultUserImage = 'https://flowing-web-resources.s3.ap-northeast-2.amazonaws.com/default-profile.png'

export const customSampleImg = 'https://flowing-web-resources.s3.ap-northeast-2.amazonaws.com/static/select_custom.webp'
export const bannerSampleImg = 'https://flowing-web-resources.s3.ap-northeast-2.amazonaws.com/static/select_banner.webp'